import Vue from 'vue'
import Vuex from 'vuex'

import activities from './activities/index'
import boards from './boards/index'
import changelogs from './changelogs/index'
import features from './features/index'
import integrations from './integrations/index'
import user from './user/index'

Vue.use(Vuex)

const subscription_test = {
  "_id":"5e853c6e309e4916d89efca3",
  "company":"5f185759deaafc5c6547ccb6",
  "creator":"5f185759deaafc5c6547ccb5",
  "subscriptionId":"0000001",
  "plan":{
     "active":true,
     "_id":"5e81084b530c2a7659982cdf",
     "name":"Watcher (Monthly)",
     "vendorId":"588067",
     "vendor":"paddle",
     "cost":39,
     "cycle":"month",
     "allowance":{
        "board":{
           "private":1,
           "public":1
        },
        "integration":{
           "intercom":false,
           "slack":false
        },
        "member":3,
        "customStatus":false,
        "customDomain":false,
        "developerApi":false
     },
     "__v":0,
     "created":"2020-03-29T20:42:51.072Z",
     "updated":"2020-03-29T20:42:51.072Z"
  },
  "created":"2020-07-22T00:00:00.000Z",
  "updated":"2020-07-22T00:00:00.000Z"
}

export default new Vuex.Store({
  state: {
    company: {},
    statuses: [],
    tags: [],
    subscription: null,
    users: [],
    pendingInvites: [],
    notifications: [],
    plans: []
  },
  mutations: {
    SET_DETAILS(state, { company, statuses, users, subscription }) {
      //state.company = company
      state.statuses = statuses
      state.users = users
      state.subscription = subscription
      //state.subscription = subscription_test
    },

    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications
    },

    DELETE_NOTIFICATIONS(state) {
      state.notifications = []
    },

    SET_COMPANY(state, company) {
      state.company = company
    },

    SET_COMPANY_CUSTOM_DOMAIN(state, customDomain) {
      state.company.customDomain = customDomain
    },

    SET_USERS(state, users) {
      state.users = users
    },

    ADD_USER(state, user) {
      const existingUser = state.users.findIndex((u) => u._id === user._id) > -1
      const existingInvite = state.pendingInvites.findIndex((invite) => invite.email === user.email) > -1
      if (!existingUser) {
        state.users = [...state.users, user]
      }
      if (existingInvite) {
        state.pendingInvites.splice(existingInvite, 1)
      }
    },

    SET_PENDING_INVITES(state, invites) {
      state.pendingInvites = invites
    },

    ADD_PENDING_INVITE(state, invite) {
      const existingInvite = state.pendingInvites.findIndex((i) => i.email === invite.email) > -1
      if (!existingInvite) {
        state.pendingInvites = [...state.pendingInvites, invite]
      }
    },
    DELETE_PENDING_INVITE(state, token) {
      let index = state.pendingInvites.findIndex((invite) => invite.token === token)
      if (index > -1) {
        state.pendingInvites.splice(index, 1)
      }
    },
    SET_STATUSES(state, statuses) {
      state.statuses = [...statuses]
    },
    SET_TAGS(state, tags) {
      state.tags = [...tags]
    },
    ADD_TAG(state, tag) {
      state.tags = [...state.tags, tag]
    },
    DELETE_TAG(stage, tag) {
      let index = state.tags.findIndex(t => t._id === tag._id)
      if (index > -1) {
        state.tags.splice(index, 1)
      }

    },

    SET_PLANS(state, plans) {
      state.plans = [...plans]
    },

    SET_SUBSCRIPTION(state, subscription) {
      state.subscription = subscription
    }
  },
  actions: {
    async getDetail({ commit }) {
      try {
        let { data } = await axios.get('company/detail')
        //console.log(data)
        commit('SET_DETAILS', data)
      } catch (error) {}
    },

    async getNotifications({ commit }) {
      try {
        let { data } = await axios.get('user/notifications')
        //console.log(data)
        commit('SET_NOTIFICATIONS', data)
      } catch (error) {}
    },

    async getCompany({ commit }, slug) {
      try {
        let { data } = await axios.get('company')
        //console.log(data)
        commit('SET_COMPANY', data)
        return data
      } catch (error) {}
    },

    async updateCompany({ commit }, form) {
      try {
        let { data } = await axios.put('company', form)
        //console.log(data)
        commit('SET_COMPANY', data)
      } catch (error) {
        if (error.response.data.errors && error.response.data.errors['customDomain.domain']) {
          error.response.data.errors['customDomain.domain'] = 'This domain is already in use.'
        }
        throw error.response.data.errors
      }
    },

    async verifyCustomDomain({ commit }) {
      try {
        let { data } = await axios.get('company/verify-domain')
        commit('SET_COMPANY_CUSTOM_DOMAIN', data)
      } catch (error) {}
    },

    async getCompanyUsers({ commit }) {
      try {
        let { data } = await axios.get('company/users')
        commit('SET_USERS', data)
      } catch (error) {
        console.log('error')
      }
    },

    async getPendingInvites({ commit }) {
      try {
        let { data } = await axios.get('company/invites')
        commit('SET_PENDING_INVITES', data)
      } catch (error) {
        console.log('error')
      }
    },

    async getTags({ commit }) {
      try {
        //console.log('getting tags!')
        let { data } = await axios.get(`tags`)
        commit('SET_TAGS', data)
      } catch (error) {}
    },

    async addTags({ commit }, tag) {
      try {
        let { data } = await axios.post(`tags`, { tag })
        commit('ADD_TAG', data)
        return data

      } catch (error) {

      }
    },

    async deleteTag({ commit }, tag) {
      try {
        let { data } = await axios.delete(`tags/${tag._id}`)
        commit('DELETE_TAG', tag)
      } catch (error) {

      }

    },

    async getStatuses({ commit }) {
      try {
        let { data } = await axios.get(`statuses`)
        commit('SET_STATUSES', data)
      } catch (error) {}
    },

    async postStatuses({ commit }, statuses) {
      try {
        let { data } = await axios.post(`statuses`, statuses)
        commit('SET_STATUSES', data)
      } catch (error) {}
    },

    async postStatusesReceived({ commit }, event) {
      const { statuses } = event
      commit('SET_STATUSES', statuses)
    },

    async postInvites({ commit }, invite) {
      try {
        let { data } = await axios.post('invites', invite)
        commit('ADD_PENDING_INVITE', data)
      } catch (error) {
        throw error.response.data.error
      }
    },

    async postInvitesReceived({ commit }, event) {
      const { invite } = event
      commit('ADD_PENDING_INVITE', invite)
    },

    async postInviteAcceptedReceived({ commit }, event) {
      const { user } = event
      commit('ADD_USER', user)
    },

    async deleteInvite({ commit }, token) {
      try {
        let { data } = await axios.delete(`invite/${token}`)
        commit('DELETE_PENDING_INVITE', token)
      } catch (error) {}
    },

    async deleteInviteReceived({ commit }, event) {
      const { invite } = event
      commit('DELETE_PENDING_INVITE', invite.token)
    },

    async getInvite({ commit }, { token }) {
      try {
        let { data } = await axios.get(`invite/${token}`)
        return data.company
      } catch (error) {}
    },

    async postInvite({ commit }, { token, form }) {
      try {
        let { data } = await axios.post(`invite/${token}`, form)
      } catch (error) {}
    },

    async getPlans({ commit }) {
      try {
        let { data } = await Vue.axios.get(`plans`)
        commit('SET_PLANS', data)
      } catch (error) {
        console.log(error)
      }
    },

    async postCard({ commit }, form) {
      try {
        let { data } = await axios.post('subscription/card', form)
        //commit('SET_SUBSCRIPTION', data)
      } catch (error) {}
    },

    async postSubscription({ commit }, form) {
      try {
        let { data } = await axios.post('subscriptions', form)
        commit('SET_SUBSCRIPTION', data)
      } catch (error) {}
    }
  },
  modules: {
    user,
    boards,
    features,
    activities,
    changelogs,
    integrations
  }
})
